// extracted by mini-css-extract-plugin
module.exports = {"rulesContainer":"rules_rulesContainer__1BSCy","active":"rules_active__1e5hN"};